import React, { useEffect } from 'react';
import { Panel } from 'rsuite';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  fetchGuestReservations,
  fetchUserPermissions
} from '../../redux/sagas/routines';
import { getGuestReservationSearchQuery } from '../../redux/Guest/selectors/components/reservation-search';
import { updateGuestReservationSearchQuery } from '../../redux/Guest/actions/components/reservation-search';
import ReservationList from '../../containers/guest/ReservationList';
import ReservationSearch from '../../containers/guest/ReservationSearch';

// eslint-disable-next-line react/prop-types
export default ({ staticContext, ...props }) => {
  const dispatch = useDispatch();
  const searchQuery = useSelector(getGuestReservationSearchQuery);
  const { id: guestId } = useParams();

  useEffect(() => {
    dispatch(fetchGuestReservations({ guestId, query: searchQuery }));
    dispatch(updateGuestReservationSearchQuery(searchQuery));
    dispatch(fetchUserPermissions());
  }, []);

  return (
    <div {...props}>
      <Panel bordered style={{ marginBottom: 10 }}>
        <ReservationSearch
          guestId={guestId}
          placeholder="Search ID or Outreach"
          isLegacyView
        />
      </Panel>
      <ReservationList guestId={guestId} isLegacyView />
    </div>
  );
};
